var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHubspot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 463.16 133.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_--Marketing_Logos_HubSpot-Primary",
    "data-name": "--Marketing/Logos/HubSpot-Primary"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Marketing_Logos_HubSpot-Primary",
    "data-name": "Marketing/Logos/HubSpot-Primary"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "cls-1",
    d: "M50.16 22.06v37.58H16.15V22.06H0v89.7h16.15V75.41h34.01v36.35h16.15v-89.7H50.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    className: "cls-1",
    d: "M118 82.77a13.36 13.36 0 11-26.72 0V44.35H76v38.42a28.65 28.65 0 1057.3 0V44.35H118v38.42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "cls-1",
    d: "M231.47 48.3c0-7.88 5.14-10.37 10.77-10.37 4.53 0 10.52 3.5 14.43 7.75l10-12c-5-6.87-15.16-11.62-23.48-11.62-16.64 0-28.63 9.87-28.63 26.24 0 30.36 36.58 20.74 36.58 37.74 0 5.24-5 9.87-10.76 9.87-9 0-12-4.5-16.15-9.25l-11.1 11.74c7.1 8.87 15.91 13.37 26.43 13.37 15.78 0 28.51-10 28.51-25.62 0-33.73-36.6-23.23-36.6-37.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "cls-1",
    d: "M457.78 97.43c-9 0-11.62-4-11.62-10.06V60.44h14.07V46.79h-14.07v-18l-15.53 7.08v54.87c0 14 9.54 21.11 22.62 21.11a30.73 30.73 0 006.12-.5l3.79-14.15c-1.71.11-3.66.23-5.38.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    className: "cls-1",
    d: "M176.18 96.17a17.66 17.66 0 1117.4-17.66 17.53 17.53 0 01-17.4 17.66m.1-51.37c-7.59 0-12.88 2.24-18 7.33V22.6h-15.34v54.72c0 20.48 14.59 34.51 31 34.51 18.23 0 34.2-14.28 34.2-33.52 0-19-14.72-33.51-31.85-33.51"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    className: "cls-1",
    d: "M310.89 95a17.66 17.66 0 1117.4-17.66A17.53 17.53 0 01310.89 95m31.95-17.46c0-19.24-16-33.52-34.2-33.52-16.4 0-31 14-31 34.51v54.73H293V103.7c5.12 5.09 10.41 7.33 18 7.33 17.12 0 31.85-14.53 31.85-33.52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    d: "M387.23 94.66a17.58 17.58 0 1117.33-17.58 17.46 17.46 0 01-17.33 17.58m5.19-51.43V27.6a12.05 12.05 0 006.84-10.85v-.36a12 12 0 00-11.85-12h-.35a12 12 0 00-11.85 12v.36a12.05 12.05 0 006.84 10.85v15.64a33.41 33.41 0 00-16 7.14L323.75 17a13.37 13.37 0 10-26.25-3.42 13.47 13.47 0 0013.35 13.58 13 13 0 006.58-1.82l41.63 32.86a34.63 34.63 0 00.52 38.57l-12.66 12.85a10.54 10.54 0 00-3.14-.52 11.33 11.33 0 1010.47 8l12.52-12.71a33.3 33.3 0 0020.46 7.05C405.89 111.37 421 96 421 77.08a34.12 34.12 0 00-28.6-33.85",
    fill: "#ff7a59",
    fillRule: "evenodd"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspot);
export default __webpack_public_path__ + "static/media/hubspot.1715d578c102db5168888ec670136a82.svg";
export { ForwardRef as ReactComponent };